(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paldy-feedback"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hasRating(form) {
    return !!form.querySelector('input[name="contact[Rating]"]:checked');
  }
  function warn(form) {
    var msg = form.querySelector('.paldy-fb__rate-msg');
    if (msg) msg.style.display = 'block';
    var wrap = form.querySelector('.paldy-fb__stars');
    if (wrap) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function bind(form) {
    if (form.__paldyGuard) return;
    form.__paldyGuard = true;
    form.addEventListener('submit', function (e) {
      if (!hasRating(form)) { e.preventDefault(); e.stopImmediatePropagation(); warn(form); }
    }, true);
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.addEventListener('click', function (e) {
      if (!hasRating(form)) { e.preventDefault(); e.stopImmediatePropagation(); warn(form); }
    }, true);
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'contact[Rating]') {
        var msg = form.querySelector('.paldy-fb__rate-msg');
        if (msg) msg.style.display = 'none';
      }
    });
  }
  function init() {
    var forms = document.querySelectorAll('form.paldy-fb');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();
})();
